import PaCommonMixin from '../PaCommonMixin.js';

export default {
    mixins: [
        PaCommonMixin,
    ],
    props: {
        section: {
            type: [Array, Object],
            required: true,
        },
        issue: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            
        };
    },
    computed: {
        customHeadingFontSize(){
            if( typeof this.section.font_size == 'undefined' 
                || this.section.font_size == null 
                || this.section.font_size == ''){
                    return '';
            }

            return `font-size: ${this.section.font_size}em;`;
        },
    },
    methods: {

        displayMorePostsForSection(section){
            let new_limit = section.item_limit + 10;
            this.$set(section, 'item_limit', new_limit);
        },

    },
}